import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: false,
  step: 0,
};

export const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    startTour: (state, action) => {
      state.active = true;
      state.step = typeof action?.payload === "number" ? action.payload : 0;
    },
    setTourStep: (state, action) => {
      const nextStep = action?.payload;
      if (typeof nextStep === "number") {
        state.step = nextStep;
      }
    },
    stopTour: (state) => {
      state.active = false;
    },
    resetTour: (state) => {
      state.active = false;
      state.step = 0;
    },
  },
});

export const { startTour, setTourStep, stopTour, resetTour } =
  tourSlice.actions;

export default tourSlice.reducer;

